import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import ContentContainer from '../../components/ContentContainer';
import PageTitle from '../../components/PageTitle';
import withUser from '../../hoc/withUser';
import Spinner from '../../components/Spinner';
import CoursesContent from './components/CoursesContent';
import { useStore } from '../../store';

const CoursesPage = observer(({ user, authToken }) => {
  const {
    rootStore: {
      profileStore,
      profileStore: { coursesStore },
    },
  } = useStore();

  const [showLoader, setShowLoader] = useState(true);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      if (!profileStore.profileData) {
        await profileStore.initProfile(user, authToken, i18n);
      }

      await profileStore.loadUser();
      await coursesStore.getAllCourses(t);

      setShowLoader(false);
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  if (showLoader) return <Spinner pageLoading />;

  return (
    <>
      <ContentContainer fullWidth={true}>
        <PageTitle titleKey={t('coursesPage.title')} subtitleKey={t('coursesPage.subtitle')} />
        <CoursesContent
          currentTrainingData={coursesStore?.currentTrainingData}
          upcomingTrainingData={coursesStore?.upcomingTrainingData}
          offerTrainingData={coursesStore?.offerTrainingData}
          historyTrainingData={coursesStore?.historyTrainingData}
        />
      </ContentContainer>
    </>
  );
});

export default withUser(CoursesPage);
